/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".settings-container h3{font-size:14px;font-weight:400}.settings-container .mat-tab-label .mat-icon{vertical-align:text-bottom;font-size:18px;margin-right:5px;width:18px;height:18px}.settings-container .tab-footer{padding-top:10px}"];
export { styles as styles };
